/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./theme/scripts/components/article-upsell.js":
/*!****************************************************!*\
  !*** ./theme/scripts/components/article-upsell.js ***!
  \****************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/lib/choozy */ "./theme/scripts/lib/choozy.js");


/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node) {
  var _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_1__["default"])(document),
    trigger = _choozy.articleHeader;
  var VISIBLE_THRESHOLD_START = parseInt(node.dataset.tresholdStart, 10) || 50;
  var VISIBLE_THRESHOLD_END = parseInt(node.dataset.tresholdEnd, 10) || 95;
  function shouldVisible() {
    var percent = document.documentElement.scrollHeight / 100;
    var scrollProgress = Math.floor((window.scrollY + window.innerHeight) / percent);
    return scrollProgress > VISIBLE_THRESHOLD_START && scrollProgress < VISIBLE_THRESHOLD_END;
  }
  function toggleActive(isActive) {
    if (isActive) {
      node.classList.add("isActive");
    } else {
      node.classList.remove("isActive");
    }
  }
  window.addEventListener("scroll", function () {
    if (trigger) {
      var _trigger$getBoundingC = trigger.getBoundingClientRect(),
        top = _trigger$getBoundingC.top,
        height = _trigger$getBoundingC.height;
      var triggerPosition = top + height + window.scrollY;
      toggleActive(triggerPosition < window.scrollY);
    } else {
      toggleActive(shouldVisible());
    }
  });
}));

/***/ }),

/***/ "./theme/scripts/components/back-to-top.js":
/*!*************************************************!*\
  !*** ./theme/scripts/components/back-to-top.js ***!
  \*************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");

/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node) {
  function onClick() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }
  node.addEventListener("click", onClick, true);
  return function () {
    return node.removeEventListener("click", onClick, true);
  };
}));

/***/ }),

/***/ "./theme/scripts/components/collapsibleContent.js":
/*!********************************************************!*\
  !*** ./theme/scripts/components/collapsibleContent.js ***!
  \********************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! choozy */ "./node_modules/.pnpm/choozy@1.0.0/node_modules/choozy/dist/choozy.mjs");
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");


/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_1__.component)(function (node, ctx) {
  var _choozy = (0,choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node),
    trigger = _choozy.trigger,
    content = _choozy.content,
    contentInner = _choozy.contentInner;
  if (!trigger) {
    return;
  }
  var handleContentHeightUpdate = function handleContentHeightUpdate() {
    content.style.setProperty("--content-height", "".concat(contentInner.clientHeight, "px"));
  };
  content.classList.add("init");
  setTimeout(handleContentHeightUpdate, 100);
  trigger.addEventListener("click", function (e) {
    var _trigger$parentElemen;
    e.preventDefault();
    handleContentHeightUpdate();
    trigger.classList.toggle("open");
    content.classList.toggle("open");
    (_trigger$parentElemen = trigger.parentElement) === null || _trigger$parentElemen === void 0 ? void 0 : _trigger$parentElemen.classList.toggle("open");
  });
  window.addEventListener("resize", handleContentHeightUpdate);
  ctx.on("collapsibleContent:update", handleContentHeightUpdate);
}));

/***/ }),

/***/ "./theme/scripts/components/drawer.js":
/*!********************************************!*\
  !*** ./theme/scripts/components/drawer.js ***!
  \********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "handleDrawerToggle": function() { return /* binding */ handleDrawerToggle; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var choozy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! choozy */ "./node_modules/.pnpm/choozy@1.0.0/node_modules/choozy/dist/choozy.mjs");


var handleDrawerToggle = function handleDrawerToggle(drawer, toggles) {
  if (drawer === "") {
    return;
  }
  function addEvx(drawerToggle) {
    function evx(e) {
      e.preventDefault();
      window.app.emit("".concat(drawer, ":toggle"), function (state) {
        return (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, "".concat(drawer, "Open"), !state["".concat(drawer, "Open")]);
      });
    }
    drawerToggle.removeEventListener("click", evx);
    drawerToggle.addEventListener("click", evx);
  }
  if (toggles.length > 0) {
    for (var i = 0; i < toggles.length; i++) {
      addEvx(toggles[i]);
    }
  }
};
var drawer = function drawer(node) {
  var drawerName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var _choozy = (0,choozy__WEBPACK_IMPORTED_MODULE_1__["default"])(node),
    overlay = _choozy.overlay,
    closeButton = _choozy.close,
    main = _choozy.main;
  var render = function render(data) {
    data && (main.innerHTML = data);
    var toggles = document.querySelectorAll(".js-".concat(drawerName, "DrawerToggle"));
    handleDrawerToggle(drawerName, toggles);
    window.app.emit("".concat(drawerName, ":rendered"));
  };
  var open = function open() {
    node.classList.add("is-active");
    document.body.classList.add("".concat(drawerName, "-open"));
    setTimeout(function () {
      node.classList.add("is-visible");
      window.app.mount();
    }, 50);
  };
  var close = function close() {
    node.classList.remove("is-visible");
    window.app.hydrate((0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, "".concat(drawerName, "Open"), false));
    window.app.emit(["".concat(drawerName, ":close")]);
    document.body.classList.remove("".concat(drawerName, "-open"));
    setTimeout(function () {
      node.classList.remove("is-active");
    }, 400);
  };
  render(window.app.getState()["".concat(drawerName)]);
  overlay && overlay.addEventListener("click", close);
  closeButton && closeButton.addEventListener("click", close);
  window.app.on("".concat(drawerName, ":toggle"), function (_ref2) {
    var drawerOpen = _ref2["".concat(drawerName, "Open")];
    // eslint-disable-next-line no-unused-expressions
    drawerOpen ? open() : close();
  });
  return {
    render: render,
    open: open,
    close: close
  };
};
/* harmony default export */ __webpack_exports__["default"] = (drawer);

/***/ }),

/***/ "./theme/scripts/components/header.js":
/*!********************************************!*\
  !*** ./theme/scripts/components/header.js ***!
  \********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");

/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node, ctx) {
  var cartCount = node.querySelector(".js-cart-count");
  var dropdownToggles = node.querySelectorAll("[data-has-dropdown]");
  var dropdownTimeout = null;
  var handleDropdownOpen = function handleDropdownOpen(e) {
    var toggle = e.target.closest("[data-has-dropdown]");
    var dropdown = toggle.querySelector("[data-dropdown]");
    clearTimeout(dropdownTimeout);
    toggle.classList.add("is-open");
    dropdown.setAttribute("aria-hidden", "false");
  };
  var handleDropdownClose = function handleDropdownClose(e) {
    var toggle = e.target.closest("[data-has-dropdown]");
    var dropdown = toggle.querySelector("[data-dropdown]");
    dropdownTimeout = setTimeout(function () {
      toggle.classList.remove("is-open");
      dropdown.setAttribute("aria-hidden", "true");
    }, 500);
  };
  dropdownToggles.forEach(function (el) {
    el.addEventListener("mouseover", handleDropdownOpen);
    el.addEventListener("mouseleave", handleDropdownClose);
  });
  ctx.on("cart:updated", function (state) {
    if (cartCount) {
      if (state.cart.item_count > 0) {
        cartCount.style.display = "flex";
      } else {
        cartCount.style.display = "none";
      }
      cartCount.innerHTML = state.cart.item_count;
    }
  });

  // Hide header on scroll page
  var lastScrollTop = 0;
  window.addEventListener("scroll", function (evt) {
    var scrollTop = document.documentElement.scrollTop;
    if (scrollTop > 150) {
      node.classList.add("announcement-remove");
      document.body.dataset.announcement && (document.body.dataset.announcement = "false");
    } else {
      node.classList.remove("announcement-remove");
      document.body.dataset.announcement && (document.body.dataset.announcement = "true");
    }
    if (scrollTop > lastScrollTop && scrollTop > 150) {
      node.classList.add("header-remove");
    } else {
      node.classList.remove("header-remove");
    }
    lastScrollTop = scrollTop;
  });
}));

/***/ }),

/***/ "./theme/scripts/components/menuDrawer.js":
/*!************************************************!*\
  !*** ./theme/scripts/components/menuDrawer.js ***!
  \************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! choozy */ "./node_modules/.pnpm/choozy@1.0.0/node_modules/choozy/dist/choozy.mjs");
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var _drawer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./drawer */ "./theme/scripts/components/drawer.js");



var attributeToggle = function attributeToggle(el, attr) {
  return el.getAttribute(attr) === "false" ? el.setAttribute(attr, "true") : el.setAttribute(attr, "false");
};
/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_1__.component)(function (node, ctx) {
  var _choozy = (0,choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(document),
    mobileMenuContent = _choozy.mobileMenuContent;
  var name = "menu";
  var init = function init() {
    var dropdownToggles = node.querySelectorAll("[data-has-dropdown]");
    dropdownToggles.forEach(function (el) {
      el.addEventListener("click", function (e) {
        if (e.target.closest("[data-dropdown]")) {
          return;
        }
        e.preventDefault();
        var toggle = e.target.closest("[data-has-dropdown]");
        var dropdown = toggle.querySelector("[data-dropdown]");
        toggle.classList.toggle("is-open");
        attributeToggle(dropdown, "aria-hidden");
      });
    });
  };
  ctx.hydrate({
    menu: mobileMenuContent.innerHTML
  });
  ctx.on("".concat(name, ":rendered"), init);
  (0,_drawer__WEBPACK_IMPORTED_MODULE_2__["default"])(node, name);
}));

/***/ }),

/***/ "./theme/scripts/components/poll.js":
/*!******************************************!*\
  !*** ./theme/scripts/components/poll.js ***!
  \******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _lib_randomUUID__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @/lib/randomUUID */ "./theme/scripts/lib/randomUUID.js");
/* harmony import */ var _lib_randomUUID__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_lib_randomUUID__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! js-cookie */ "./node_modules/.pnpm/js-cookie@3.0.5/node_modules/js-cookie/dist/js.cookie.mjs");
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");







var VOTER_KEY = "poll_voter";
var POLL_API_URL = window.theme.polls.apiUrl;
var DOMAIN = window.theme.polls.domain;
function calculateSumForEachAnswer(data) {
  return data.reduce(function (acc, item) {
    Object.entries(item).forEach(function (_ref) {
      var _ref2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__["default"])(_ref, 2),
        question = _ref2[0],
        answerIndexes = _ref2[1];
      var answerIndex = answerIndexes[0];
      acc[question] = acc[question] || {};
      acc[question][answerIndex] = (acc[question][answerIndex] || 0) + 1;
    });
    return acc;
  }, {});
}
function toggleDisabled(elements) {
  var disabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  Array.from(elements).forEach(function (element) {
    return element.disabled = disabled;
  });
}
function generateInput(question, questionData, answer, answersData, index, disabled, allowMultipleSelect, totalVotes) {
  var type = allowMultipleSelect ? "checkbox" : "radio";
  var checked = questionData && questionData.includes(index) ? "checked" : "";
  var answerVotes = answersData[index];
  var percent = (answerVotes / totalVotes * 100).toFixed();
  var maxVotes = Math.max.apply(Math, (0,_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__["default"])(Object.values(answersData)));
  return "\n    <div class=\"poll__input\">\n      <input\n        type=\"".concat(type, "\"\n        name=\"").concat(question.handle, "\"\n        id=\"").concat(question.handle, "-").concat(answer.handle, "\"\n        ").concat(checked, "\n        ").concat(disabled, "\n      >\n      <label for=\"").concat(question.handle, "-").concat(answer.handle, "\">\n        <div>").concat(answer.name, "</div>\n        <div>\n          <strong class=\"c-brand-primary\">").concat(percent, "%</strong>\n          (").concat(answerVotes, " votes)\n        </div>\n        <div class=\"poll__input-progress\" style=\"--progress-width: ").concat(answerVotes / maxVotes * 100, "%\"></div>\n      </label>\n    </div>\n  ");
}
function generateFormGroups(question, questionData, answersData, formDisabled, allowMultipleSelect, totalVotes) {
  var inputs = question.answers.map(function (answer, index) {
    return generateInput(question, questionData, answer, answersData, index, formDisabled, allowMultipleSelect, totalVotes);
  }).join("");
  return "\n    <div class=\"poll__form-group\">\n      ".concat(inputs, "\n    </div>\n  ");
}
/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_6__.component)(function (node) {
  var pollId = node.dataset.pollId;
  var voterId = js_cookie__WEBPACK_IMPORTED_MODULE_5__["default"].get(VOTER_KEY) || crypto.randomUUID();
  var apiUrl = new URL(POLL_API_URL);
  apiUrl.pathname = "".concat(apiUrl.pathname, "/").concat(pollId, "/").concat(voterId);
  js_cookie__WEBPACK_IMPORTED_MODULE_5__["default"].set(VOTER_KEY, voterId, {
    domain: DOMAIN
  });
  function postData(_x, _x2) {
    return _postData.apply(this, arguments);
  }
  function _postData() {
    _postData = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default().mark(function _callee(url, bodyData) {
      var response;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch(url, {
              method: "POST",
              body: JSON.stringify(bodyData)
            });
          case 3:
            response = _context.sent;
            _context.next = 6;
            return response.json();
          case 6:
            return _context.abrupt("return", _context.sent);
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            console.error("Error when sending poll data", _context.t0);
          case 12:
            return _context.abrupt("return", null);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 9]]);
    }));
    return _postData.apply(this, arguments);
  }
  function retrieveData(_x3) {
    return _retrieveData.apply(this, arguments);
  }
  function _retrieveData() {
    _retrieveData = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default().mark(function _callee2(url) {
      var response;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return fetch(url);
          case 3:
            response = _context2.sent;
            _context2.next = 6;
            return response.json();
          case 6:
            return _context2.abrupt("return", _context2.sent);
          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](0);
            console.error("Error when retrieving poll data", _context2.t0);
          case 12:
            return _context2.abrupt("return", null);
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 9]]);
    }));
    return _retrieveData.apply(this, arguments);
  }
  function render(_x4) {
    return _render.apply(this, arguments);
  }
  function _render() {
    _render = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default().mark(function _callee3(fetchedData) {
      var name, data, fields, questions, parsedData, title, totalInitialVotes, totalVotes, voterData, formDisabled, allowMultipleSelect, answersChart, formGroups, buttonClassName;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            name = fetchedData.name, data = fetchedData.data, fields = fetchedData.fields, questions = fetchedData.questions;
            parsedData = data ? JSON.parse(data) : {
              voters: {}
            };
            title = questions.length === 1 ? questions[0].name : name;
            totalInitialVotes = questions.reduce(function (votes, question) {
              return votes + question.answers.reduce(function (v, a) {
                return v + a.initialVotes;
              }, 0);
            }, 0);
            totalVotes = Object.keys(parsedData.voters).length + totalInitialVotes;
            voterData = parsedData.voters[voterId];
            formDisabled = voterData ? "disabled" : "";
            allowMultipleSelect = fields.find(function (field) {
              return field.key === "allow_multiple_select";
            }).value === "true";
            answersChart = calculateSumForEachAnswer(Object.values(parsedData.voters));
            formGroups = questions.map(function (question) {
              var questionData = voterData ? voterData[question.handle] : undefined;
              var answersData = question.answers.reduce(function (acc, answer, index) {
                var chart = answersChart[question.handle] || {};
                acc[index] = chart[index] ? chart[index] + answer.initialVotes : answer.initialVotes;
                return acc;
              }, {});
              return generateFormGroups(question, questionData, answersData, formDisabled, allowMultipleSelect, totalVotes);
            }).join("");
            buttonClassName = "button button--primary button--style button--large caps";
            node.innerHTML = "\n      <h3 class=\"poll__title c-brand-secondary m0\">".concat(title, "</h3>\n      <p class=\"poll__total-votes\">Total votes: ").concat(totalVotes, " votes</p>\n      <form class=\"poll__form\">\n        ").concat(formGroups, "\n        <button type=\"submit\" class=\"").concat(buttonClassName, "\" ").concat(formDisabled, ">Submit vote</button>\n      </form>\n    ");
          case 12:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _render.apply(this, arguments);
  }
  function addListeners() {
    var form = node.querySelector("form");
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      toggleDisabled(form.elements);
      var formData = {};
      Array.from(form.elements).filter(function (element) {
        return element.tagName === "INPUT";
      }).forEach(function (element, index) {
        formData[element.name] = formData[element.name] || [];
        if (element.checked) {
          formData[element.name].push(index);
        }
      });
      postData(apiUrl, formData).then(function (data) {
        return render(data.poll);
      }).then(addListeners);
    });
  }
  retrieveData(apiUrl).then(render).then(addListeners);
}));

/***/ }),

/***/ "./theme/scripts/components/progress-bar.js":
/*!**************************************************!*\
  !*** ./theme/scripts/components/progress-bar.js ***!
  \**************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! choozy */ "./node_modules/.pnpm/choozy@1.0.0/node_modules/choozy/dist/choozy.mjs");
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");


/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_1__.component)(function (node) {
  var _choozy = (0,choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(document),
    section = _choozy.section;
  if (!section) {
    return;
  }
  node.classList.add("isActive");
  document.body.classList.add("hasProgressBar");
  var onScroll = function onScroll() {
    var scrollDistance = -section.getBoundingClientRect().top;
    var progressPercentage = scrollDistance / (section.getBoundingClientRect().height - document.documentElement.clientHeight) * 100;
    var percentage = Math.floor(progressPercentage);
    node.style.setProperty("--progress", "".concat(percentage, "%"));
    if (percentage <= 0) {
      node.style.setProperty("--progress", "0%");
    } else if (percentage > 100) {
      node.style.setProperty("--progress", "100%");
    }
  };
  onScroll();
  window.addEventListener("scroll", onScroll);
}));

/***/ }),

/***/ "./theme/scripts/lib/choozy.js":
/*!*************************************!*\
  !*** ./theme/scripts/lib/choozy.js ***!
  \*************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! choozy */ "./node_modules/.pnpm/choozy@1.0.0/node_modules/choozy/dist/choozy.mjs");

/* harmony default export */ __webpack_exports__["default"] = (function (node) {
  return (0,choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node);
});

/***/ }),

/***/ "./theme/scripts/lib/handleize.js":
/*!****************************************!*\
  !*** ./theme/scripts/lib/handleize.js ***!
  \****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ handleize; }
/* harmony export */ });
function handleize(string) {
  if (!string) {
    return null;
  }
  return string.toLowerCase().replace(/[’'"]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/-$/, "").replace(/^-/, "");
}

/***/ }),

/***/ "./theme/scripts/lib/randomUUID.js":
/*!*****************************************!*\
  !*** ./theme/scripts/lib/randomUUID.js ***!
  \*****************************************/
/***/ (function() {

/* eslint-disable no-bitwise */
if (!("randomUUID" in crypto)) {
  crypto.randomUUID = function randomUUID() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
      return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
    });
  };
}

/***/ }),

/***/ "./theme/scripts/lib/videos.js":
/*!*************************************!*\
  !*** ./theme/scripts/lib/videos.js ***!
  \*************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ videos; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var choozy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! choozy */ "./node_modules/.pnpm/choozy@1.0.0/node_modules/choozy/dist/choozy.mjs");


function videos() {
  var _choozy = (0,choozy__WEBPACK_IMPORTED_MODULE_1__["default"])(document),
    videoElements = _choozy.videos;
  if (!videoElements) {
    return;
  }
  function generateURL(id) {
    var query = "?rel=0&showinfo=0&autoplay=1";
    return "https://www.youtube.com/embed/".concat(id).concat(query);
  }
  function parseMediaURL(media) {
    var regexp = /https:\/\/i\.ytimg\.com\/vi\/([a-zA-Z0-9_-]+)/i;
    var url = media.src;
    var match = url.match(regexp);
    return match[1];
  }
  function createIframe(id) {
    var iframe = document.createElement("iframe");
    iframe.setAttribute("allowfullscreen", "");
    iframe.setAttribute("allow", "autoplay");
    iframe.setAttribute("src", generateURL(id));
    iframe.classList.add("video__media");
    return iframe;
  }
  function setupVideo(video) {
    var link = video.querySelector(".video__link");
    var media = video.querySelector(".video__media");
    var button = video.querySelector(".video__button");
    var id = parseMediaURL(media);
    video.addEventListener("click", function () {
      var iframe = createIframe(id);
      link.remove();
      button.remove();
      video.appendChild(iframe);
    });
    link.addEventListener("click", function (event) {
      event.preventDefault();
    });
    video.classList.add("video--enabled");
  }
  function initVideos() {
    for (var i = 0; i < videoElements.length; i++) {
      setupVideo(videoElements[i]);
    }
  }
  if (videoElements.length) {
    initVideos();
  } else if ((0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__["default"])(videoElements) === "object") {
    setupVideo(videoElements);
  }
}

/***/ }),

/***/ "./theme/scripts/pages/Article.js":
/*!****************************************!*\
  !*** ./theme/scripts/pages/Article.js ***!
  \****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! choozy */ "./node_modules/.pnpm/choozy@1.0.0/node_modules/choozy/dist/choozy.mjs");
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var _lib_handleize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/lib/handleize */ "./theme/scripts/lib/handleize.js");



/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_1__.component)(function (node) {
  var _choozy = (0,choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node),
    articleBody = _choozy.articleBody;
  var headings = articleBody.querySelectorAll("h1, h2, h3, h4, h5, h6");
  headings.forEach(function (heading) {
    heading.id = "hash-".concat((0,_lib_handleize__WEBPACK_IMPORTED_MODULE_2__["default"])(heading.innerText));
  });
}));

/***/ }),

/***/ "./theme/styles/blogs.css":
/*!********************************!*\
  !*** ./theme/styles/blogs.css ***!
  \********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js":
/*!**********************************************************************************!*\
  !*** ./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js ***!
  \**********************************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "component": function() { return /* binding */ u; },
/* harmony export */   "picoapp": function() { return /* binding */ c; }
/* harmony export */ });
var n=function(n){if("object"!=typeof(t=n)||Array.isArray(t))throw"state should be an object";var t},t=function(n,t,r,e){return(o=n,o.reduce(function(n,t,r){return n.indexOf(t)>-1?n:n.concat(t)},[])).reduce(function(n,r){return n.concat(t[r]||[])},[]).map(function(n){return n(r,e)});var o};function r(r){void 0===r&&(r={});var e={};return{getState:function(){return Object.assign({},r)},hydrate:function(o){return n(o),Object.assign(r,o),function(){var n=["*"].concat(Object.keys(o));t(n,e,r)}},on:function(n,t){return(n=[].concat(n)).map(function(n){return e[n]=(e[n]||[]).concat(t)}),function(){return n.map(function(n){return e[n].splice(e[n].indexOf(t),1)})}},emit:function(o,u,c){var i=("*"===o?[]:["*"]).concat(o);(u="function"==typeof u?u(r):u)&&(n(u),Object.assign(r,u),i=i.concat(Object.keys(u))),t(i,e,r,c)}}}r();var e=function(n){return"object"==typeof n&&!Array.isArray(n)},o=function(n){return"function"==typeof n};function u(n){return function(t,r){var e=[];return{subs:e,unmount:n(t,Object.assign({},r,{on:function(n,t){var o=r.on(n,t);return e.push(o),o}})),node:t}}}function c(n,t,u){void 0===n&&(n={}),void 0===t&&(t={}),void 0===u&&(u=[]);var c=r(t),i=[];return{on:c.on,emit:c.emit,getState:function(){return c.getState()},add:function(t){if(!e(t))throw"components should be an object";Object.assign(n,t)},use:function(n){if(!o(n))throw"plugins should be a function";u.push(n)},hydrate:function(n){return c.hydrate(n)},mount:function(t){void 0===t&&(t="data-component"),t=[].concat(t);for(var r=0;r<t.length;r++){for(var a=t[r],f=[].slice.call(document.querySelectorAll("["+a+"]")),s=function(){for(var t=f.pop(),r=t.getAttribute(a).split(/\s/),s=0;s<r.length;s++){var v=n[r[s]];if(v){t.removeAttribute(a);try{var d=u.reduce(function(n,r){var o=r(t,c);return e(o)?Object.assign(n,o):n},{}),m=v(t,Object.assign({},d,c));o(m.unmount)&&i.push(m)}catch(n){console.error(n),c.emit("error",{error:n}),c.hydrate({error:void 0})}}}};f.length;)s();c.emit("mount")}},unmount:function(){for(var n=i.length-1;n>-1;n--){var t=i[n],r=t.subs;(0,t.unmount)(t.node),r.map(function(n){return n()}),i.splice(n,1)}c.emit("unmount")}}}
//# sourceMappingURL=picoapp.es.js.map


/***/ }),

/***/ "./node_modules/.pnpm/sscroll@1.1.2/node_modules/sscroll/dist/sscroll.es.js":
/*!**********************************************************************************!*\
  !*** ./node_modules/.pnpm/sscroll@1.1.2/node_modules/sscroll/dist/sscroll.es.js ***!
  \**********************************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
var n=function(n){return n.getBoundingClientRect().top+window.pageYOffset};/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(t,o){if(void 0===o&&(o={}),t){var r,e,i,u,f=n(t)+(o.offset||0),a=o.duration||500;return a?(r=window.pageYOffset,e=f,i=a,u=function(n,t,o,r){return(n/=r/2)<1?o/2*n*n+t:-o/2*(--n*(n-2)-1)+t},function(n,t){var o,f,a,c;return a=function d(w){return requestAnimationFrame(function(l){f||(f=l),o=l-f,c=Math.round(u(o,r,e-r,i)),(e>r?c<e&&w<=e:c>e&&w>=e)&&o<=i?(a=d(c),n(c)):(n(e),t&&t())})}(r),function(){cancelAnimationFrame(a)}})(function(n){return window.scrollTo(0,n)}):window.scrollTo(0,f)}};
//# sourceMappingURL=sscroll.es.js.map


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/regeneratorRuntime.js":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/regeneratorRuntime.js ***!
  \*************************************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(/*! ./typeof.js */ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/typeof.js")["default"]);
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/typeof.js":
/*!*************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/typeof.js ***!
  \*************************************************************************************************/
/***/ (function(module) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/regenerator/index.js":
/*!****************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/regenerator/index.js ***!
  \****************************************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(/*! ../helpers/regeneratorRuntime */ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/regeneratorRuntime.js")();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js":
/*!***************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js ***!
  \***************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js ***!
  \*************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js":
/*!****************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js ***!
  \****************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _arrayWithoutHoles; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./arrayLikeToArray.js */ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js");

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__["default"])(arr);
}

/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js":
/*!***************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js ***!
  \***************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/defineProperty.js":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/defineProperty.js ***!
  \*************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./toPropertyKey.js */ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js");

function _defineProperty(obj, key, value) {
  key = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__["default"])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/iterableToArray.js":
/*!**************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/iterableToArray.js ***!
  \**************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js":
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js ***!
  \*******************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _iterableToArrayLimit; }
/* harmony export */ });
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js":
/*!**************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js ***!
  \**************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js":
/*!****************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js ***!
  \****************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _nonIterableSpread; }
/* harmony export */ });
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/slicedToArray.js":
/*!************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/slicedToArray.js ***!
  \************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _slicedToArray; }
/* harmony export */ });
/* harmony import */ var _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./arrayWithHoles.js */ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js");
/* harmony import */ var _iterableToArrayLimit_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./iterableToArrayLimit.js */ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js");
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./unsupportedIterableToArray.js */ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js");
/* harmony import */ var _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./nonIterableRest.js */ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js");




function _slicedToArray(arr, i) {
  return (0,_arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__["default"])(arr) || (0,_iterableToArrayLimit_js__WEBPACK_IMPORTED_MODULE_1__["default"])(arr, i) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__["default"])(arr, i) || (0,_nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__["default"])();
}

/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js":
/*!****************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js ***!
  \****************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _toConsumableArray; }
/* harmony export */ });
/* harmony import */ var _arrayWithoutHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./arrayWithoutHoles.js */ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js");
/* harmony import */ var _iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./iterableToArray.js */ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/iterableToArray.js");
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./unsupportedIterableToArray.js */ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js");
/* harmony import */ var _nonIterableSpread_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./nonIterableSpread.js */ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js");




function _toConsumableArray(arr) {
  return (0,_arrayWithoutHoles_js__WEBPACK_IMPORTED_MODULE_0__["default"])(arr) || (0,_iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__["default"])(arr) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__["default"])(arr) || (0,_nonIterableSpread_js__WEBPACK_IMPORTED_MODULE_3__["default"])();
}

/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/toPrimitive.js":
/*!**********************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/toPrimitive.js ***!
  \**********************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _toPrimitive; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/typeof.js");

function _toPrimitive(input, hint) {
  if ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js":
/*!************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js ***!
  \************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _toPropertyKey; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _toPrimitive_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./toPrimitive.js */ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/toPrimitive.js");


function _toPropertyKey(arg) {
  var key = (0,_toPrimitive_js__WEBPACK_IMPORTED_MODULE_1__["default"])(arg, "string");
  return (0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(key) === "symbol" ? key : String(key);
}

/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/typeof.js":
/*!*****************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/typeof.js ***!
  \*****************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js":
/*!*************************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js ***!
  \*************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./arrayLikeToArray.js */ "./node_modules/.pnpm/@babel+runtime@7.20.13/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js");

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__["default"])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__["default"])(o, minLen);
}

/***/ }),

/***/ "./node_modules/.pnpm/choozy@1.0.0/node_modules/choozy/dist/choozy.mjs":
/*!*****************************************************************************!*\
  !*** ./node_modules/.pnpm/choozy@1.0.0/node_modules/choozy/dist/choozy.mjs ***!
  \*****************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(e,t){return void 0===e&&(e=document),void 0===t&&(t="js-"),[].slice.call(e.querySelectorAll('*[class*="'+t+'"]')).reduce(function(e,c){var r=("string"==typeof c.className?c.className:c.className.baseVal).split(t)[1].split(" ")[0].trim();return e[r]=e[r]?e[r].constructor===Array?e[r].concat(c):[e[r],c]:c,e},{})}
//# sourceMappingURL=choozy.mjs.map


/***/ }),

/***/ "./node_modules/.pnpm/js-cookie@3.0.5/node_modules/js-cookie/dist/js.cookie.mjs":
/*!**************************************************************************************!*\
  !*** ./node_modules/.pnpm/js-cookie@3.0.5/node_modules/js-cookie/dist/js.cookie.mjs ***!
  \**************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ api; }
/* harmony export */ });
/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */




/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
/*!********************************!*\
  !*** ./theme/scripts/blogs.js ***!
  \********************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _styles_blogs_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../styles/blogs.css */ "./theme/styles/blogs.css");
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var sscroll__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! sscroll */ "./node_modules/.pnpm/sscroll@1.1.2/node_modules/sscroll/dist/sscroll.es.js");
/* harmony import */ var _components_article_upsell__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/components/article-upsell */ "./theme/scripts/components/article-upsell.js");
/* harmony import */ var _components_back_to_top__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @/components/back-to-top */ "./theme/scripts/components/back-to-top.js");
/* harmony import */ var _components_collapsibleContent__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @/components/collapsibleContent */ "./theme/scripts/components/collapsibleContent.js");
/* harmony import */ var _components_header__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @/components/header */ "./theme/scripts/components/header.js");
/* harmony import */ var _components_menuDrawer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @/components/menuDrawer */ "./theme/scripts/components/menuDrawer.js");
/* harmony import */ var _components_poll__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @/components/poll */ "./theme/scripts/components/poll.js");
/* harmony import */ var _components_progress_bar__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @/components/progress-bar */ "./theme/scripts/components/progress-bar.js");
/* harmony import */ var _lib_videos__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @/lib/videos */ "./theme/scripts/lib/videos.js");
/* harmony import */ var _pages_Article__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @/pages/Article */ "./theme/scripts/pages/Article.js");












var state = {
  cartOpen: false,
  reviewOpen: false,
  menuOpen: false
};
var components = {
  Article: _pages_Article__WEBPACK_IMPORTED_MODULE_11__["default"],
  ArticleUpsell: _components_article_upsell__WEBPACK_IMPORTED_MODULE_3__["default"],
  BackToTop: _components_back_to_top__WEBPACK_IMPORTED_MODULE_4__["default"],
  collapsibleContent: _components_collapsibleContent__WEBPACK_IMPORTED_MODULE_5__["default"],
  header: _components_header__WEBPACK_IMPORTED_MODULE_6__["default"],
  menuDrawer: _components_menuDrawer__WEBPACK_IMPORTED_MODULE_7__["default"],
  ProgressBar: _components_progress_bar__WEBPACK_IMPORTED_MODULE_9__["default"],
  Poll: _components_poll__WEBPACK_IMPORTED_MODULE_8__["default"]
};
var app = (0,picoapp__WEBPACK_IMPORTED_MODULE_1__.picoapp)(components, state);
(0,_lib_videos__WEBPACK_IMPORTED_MODULE_10__["default"])();
window.app = app;
app.on(["cart:toggle", "review:toggle", "menu:toggle"], function (_ref) {
  var cartOpen = _ref.cartOpen,
    reviewOpen = _ref.reviewOpen,
    menuOpen = _ref.menuOpen;
  if ((cartOpen || reviewOpen || menuOpen) && !document.body.classList.contains("overflow-hidden")) {
    document.body.classList.add("overflow-hidden");
  }
});
app.on(["cart:close", "review:close", "menu:close"], function (_ref2) {
  var cartOpen = _ref2.cartOpen,
    reviewOpen = _ref2.reviewOpen,
    menuOpen = _ref2.menuOpen;
  if (!(cartOpen || reviewOpen || menuOpen)) {
    document.body.classList.remove("overflow-hidden");
  }
});
app.on("app:update", function () {
  app.unmount();
  app.mount();
});

// Sections
document.addEventListener("shopify:section:load", function () {
  app.unmount();
  app.mount();
});
document.addEventListener("shopify:section:unload", function () {
  app.unmount();
  app.mount();
  app.unmount();
  app.mount();
});
document.querySelectorAll('a[href^="#"]').forEach(function (link) {
  link.addEventListener("click", function (e) {
    e.preventDefault();
    var target = document.querySelector(link.hash);
    target && (0,sscroll__WEBPACK_IMPORTED_MODULE_2__["default"])(target, {
      duration: 500,
      offset: -100
    });
  });
});
app.mount();
}();
/******/ })()
;